import "./Experience.css";
import Data from "./Data";
import Card from "./Card";

const Experience = () => {
  return (
    <section className="resume container section" id="experience">
      <h2 className="section__title">
        Experience
      </h2>

      <div className="resume__container grid">
        <div className="timeline grid">
          {Data.map((val, id) => {
            if (val.category === "first-col") {
              return (
                <Card
                  key={id}
                  icon={val.icon} 
                  title={val.title}
                  duration={val.time}
                  description={val.desc}
                />
              )
            };

            return null;
          })}
        </div>
      </div>
    </section>
  )
}

export default Experience